//enums
import { ActivityEventTypesEnums } from '../../enums';

export const getActivityIcon = (eventId: number) =>
  Object.values(ActivityEventTypesEnums).find((event) => event === eventId);
